import React, { FC, PropsWithChildren, useCallback } from 'react';
import { useStore } from 'react-redux';
import Modal, { IModalProps } from '@bridebook/web/app-shared/components/modal';
import buggyfill from '@bridebook/web/components/common/buggyfill.hoc';
import { onModalToggle } from '@bridebook/web/lib/bbcommon/actions';
import { useDispatch, useSelector } from '@bridebook/web/lib/utils';
import { getOpenedModalIds } from '@bridebook/web/lib/bbcommon/selectors';

interface IProps extends Omit<IModalProps, 'onModalToggle' | 'store' | 'openedModalIds'> {}
const ConnectedModal = buggyfill(Modal) as FC<PropsWithChildren<IModalProps>>;

const ConnectedModalWithStore: FC<PropsWithChildren<IProps>> = (props) => {
  const store = useStore();
  const dispatch = useDispatch();
  const openedModalIds = useSelector(getOpenedModalIds);
  const onModalToggleCb = useCallback(
    (show: boolean, id: string) => dispatch(onModalToggle({ show, id })),
    [dispatch],
  );

  return (
    <ConnectedModal
      {...props}
      store={store}
      onModalToggle={onModalToggleCb}
      openedModalIds={openedModalIds}
    />
  );
};

export default ConnectedModalWithStore;
